import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-146bde7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/WEAS_LOGO.png",
    alt: "WEAS_LOGO"
  })
], -1))

import { SamplingPoint } from "@/types/samplingpoint.type";
// import { getSamplingPointNames } from "@/service/samplingpoint.service";
import { getSamplingPointsNoRelations } from "@/service/samplingpoint.service";
import { reactive, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

interface ImportFilter {
  samplingPoint: SamplingPoint;
}

//- Combos

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useI18n();
const router = useRouter();

const samplingPoints = ref<SamplingPoint[]>([]);

//- Datos reactivos
const filter = reactive<ImportFilter>({
  samplingPoint: {} as SamplingPoint,
});

// -Mounted
onMounted(async () => {
  samplingPoints.value = (await getSamplingPointsNoRelations())?.data || [];
  samplingPoints.value.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
});

//- Funciones

const goSample = () => {
  if (filter.samplingPoint?.id) {
    router.push({
      path: `/support/import/${filter.samplingPoint?.id}`,
      query: {
        samplingPoint: filter.samplingPoint?.id,
      },
    });
  }
};

// - VUE EXPOSE
expose({
  filter,
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { class: "header-import page-title" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("menu.importData")), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "card-import" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { class: "subtitle" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("subtitle.import")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { class: "row-select" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              placeholder: _unref(t)('placeholder.selectImport'),
              modelValue: _unref(filter).samplingPoint,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).samplingPoint) = $event)),
              filterable: "",
              "value-key": "id",
              onChange: goSample,
              class: "select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option.id,
                    label: option.name,
                    value: option
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        }),
        _hoisted_1
      ]),
      _: 1
    })
  ]))
}
}

})